export default {
  id: 'dashboard-overview',
  title: 'Dashboard Overview',
  content: `## Dashboard Overview

The dashboard is the first screen you see after logging in. It gives you a snapshot of your trading activity and quick access to everything in the app.

---

## What's on the Dashboard

| Section | What it shows |
|---|---|
| Portfolio Value | Current virtual capital value including open positions |
| Today's P&L | Net profit or loss for the current trading day |
| Open Positions | Number of active trades |
| Discipline Score | Your current score out of 100 |
| Recent Trades | Last 5 executed trades with outcome |
| Market Pulse | Top movers and scanner highlights for the day |

---

## Portfolio Value

This is your **total virtual capital** — starting ₹10,00,000 — adjusted for:

- Cash balance (uninvested)
- Current value of open positions (marked to last fetched price)
- Realised P&L from closed trades

> Prices update periodically — not in real time. The value shown reflects the last fetched price for each held stock.

**Example:**
> Starting capital: ₹10,00,000
> Invested in 2 open positions: ₹50,000
> Current market value of those positions: ₹52,400
> Cash balance: ₹9,50,000
> Portfolio value: ₹10,02,400

---

## Discipline Score Widget

A number from **0 to 100** shown prominently on the dashboard. It reflects the quality of your recent trading decisions — not your P&L.

- **Above 80** — Excellent discipline
- **60–80** — Good, with room to improve
- **Below 60** — Patterns of impulsive or undisciplined decisions detected

Tap it to go directly to your full Discipline Report.

---

## Quick Actions

From the dashboard you can tap directly into:

- **Trade** — Place a new order
- **Orders** — View pending and open orders
- **ACT** — Start today's practice scenarios
- **Nyx AI** — Open the AI coach`,
};
